export const InternalTransferIneligibleContent = {
  checklist: [
    `You are not the primary owner on the account`,
    `You haven’t upgraded your mutual-fund-only account to a Vanguard Brokerage Account`,
    `Your account is approved for margin or option trading`,
    `Your account has no available balance to transfer`,
    `Your account is an advised account or enrolled in Digital Advisor`,
    `You have a Cash Plus Account with no Money Market Funds`,
  ],
  contactUs: {
    contactusHeading: `You don’t have any accounts eligible to make a transfer from`,
    contactusDesc: `The following are some common reasons your accounts may be ineligible for transfer using this process:`,
  },
  buttonLabel: 'View my accounts',
  upgradeAccountHeader: 'Need to upgrade your account before continuing?',
  upgradeAccountDescription: {
    link: 'Complete the process,',
    linkHref: 'https://personal1.vanguard.com/utb-upgrade-to-brokerage/',
    part2: ' then return to ',
    internalTransferLink: 'internal transfers',
    itLinkHref: 'https://www.vanguard.com/internaltransfer',
    part3: ' to complete your request.',
    linkAriaLabel: 'opens a new window / opens in a new tab',
  },
  lightbulbAlt: `Lightbulb with lines to indicate it shining`,
  additionalLinks: {
    header: `Looking for a different type of transfer?`,
    gifting: {
      title: `Gifting`,
      href: `https://investor.vanguard.com/gifting-stock`,
      description: `Transfer to an account or organization you don’t own`,
    },
    retirement: {
      title: `Retirement transfers`,
      href: `<RETIREMENT_LINK>`,
      description: `Transfer to/from IRA accounts`,
    },
    cash: {
      title: `Cash transfers`,
      href: `https://personal1.vanguard.com/awg-cash-transfer/transfer/select-type`,
      description: `Transfer to/from Cash Plus accounts or contribute cash from your bank to another account`,
    },
    external: {
      title: `External transfers`,
      href: `https://investor.vanguard.com/account-transfer`,
      description: `Transfer money into Vanguard from another company`,
    },
  },
};
